const IMPERSONATION_SESSION_KEY = "impersonation-session";

export function markImpersonationSession(): void {
  if (typeof window === "undefined") return;
  window.sessionStorage.setItem(IMPERSONATION_SESSION_KEY, "1");
}

export function isImpersonationSession(): boolean {
  if (typeof window === "undefined") return false;
  return window.sessionStorage.getItem(IMPERSONATION_SESSION_KEY) === "1";
}

export function clearImpersonationSession(): void {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(IMPERSONATION_SESSION_KEY);
}
